import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './CheckBoxField.scss'

export default class CheckBoxField extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    fieldValue: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    fieldOnlyBoolean: PropTypes.bool,
    readOnly: PropTypes.bool
  }

  render() {
    return (
      <div className="group">
        <div className="input-wrapper">
          {!this.props.fieldOnlyBoolean ? (
            <label className="header" htmlFor={this.props.fieldName}>
              {this.props.name}
            </label>
          ) : null}
          <input
            name={this.props.fieldName}
            type="checkbox"
            checked={this.props.fieldValue || false}
            onChange={this.handleChange}
            disabled={this.props.readOnly}
          />
        </div>
      </div>
    )
  }

  handleChange = event => {
    this.props.onChange(event.target.checked, this.props.fieldName)
  }
}
